import React from 'react';

import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

import './ConnectedCalendarIcon.scss';
import { WpIcon } from 'Wpds/components/icon';

function ConnectedCalendarIcon() {
  return (
    <div className="connected-calendar-icon d-flex">
      <WpTooltip placement="top">
        <WpTooltipTrigger>
          <span className="connected-calendar-icon-calendar">
            <WpIcon name="calendar-star" />
          </span>
        </WpTooltipTrigger>
        <WpTooltipContent>
          This meeting is connected to your calendar! You’ll get reminders about upcoming meetings and a link to the
          agenda will show up in meeting invites.
        </WpTooltipContent>
      </WpTooltip>
    </div>
  );
}

export default ConnectedCalendarIcon;
